<app-nav></app-nav>
<div class="partner-screen">
    <div class='partner-tabs'>
        <ul>
            <li routerLink='../'>Home</li>
            <li routerLink='/agent-dash/dashbaord'>Dashboard</li>
            <li routerLink='/agent-dash/statistics'>Statistics</li>
            <li routerLink='/agent-dash/retrieve-quote'>Retrieve Quotes</li>
        </ul>
    </div>
    <div class="container">
        <div class="flex-container">
            <div class="partner_prod_box" (click)="redirectoAgentMotor()">
                <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/motor-insurance.svg" />
                <p>Car Insurance</p>
            </div>
            <div class="partner_prod_box " (click)="redirectoAgentDPI()">
                <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/Dr-PI-icon.svg" />
                <p>Doctor Professional Indemnity Insurance</p>
            </div>
            <div class="partner_prod_box " (click)="redirectoAgentWC()">
                <img src="assets/images/Workmen.svg" height="28px" width="28px"/>
                <p>Workmen Compensation</p>
            </div>
            <div class="partner_prod_box" (click)="redirectoAgentTraveInsurance()">
                <img src="assets/images/hospital-cash.png" height="28px" width="28px"/>
                <p>Hospital Cash</p>
            </div>
            <div class="partner_prod_box" (click)="redirectoAgentFHI()">
                <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/fhi-icon-home.svg" />
                <p>Health Insurance</p>
            </div>
            <div class="partner_prod_box" (click)="redirectoTermLifeInsurance()">
                <img src="assets/images/max-life.svg" />
                <p>Term Life Insurance</p>
            </div>
            <div class="partner_prod_box" (click)="redirectoMarine()">
                <img src="assets/images/Marine.svg" height="28px" width="28px" />
                <p>Marine Insurance</p>
            </div>
            <div class="partner_prod_box" (click)="redirectoAgentPropertyInsurance()">
                <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/sign-up/icons/personal-accident-icon.svg" height="28px" width="28px" />
                <p>Personal Accident</p>
            </div>
        </div>
    </div>
</div>